 <template>
    <div class="flex flex-wrap box justify-between gap-y-2 gap-x-8 xl:gap-x-12">
        <div class="w-1/2">
            <div class="flex mb-2">
                <jet-label for="pricing_level" value="Pricing Levels" class="w-32 align-top leading-7" />
                <div class="flex flex-1 flex-col">
                    <multiselect
                        v-model="form.pricing_level_ids"
                        :options="pricingLevelOptions"
                        placeholder="All levels"
                        mode="multiple"
                        :closeOnSelect="false"
                        class="multi-lg"
                        :classes="{multipleLabel: 'w-full px-2'}"
                    >
                        <template v-slot:multiplelabel="{ values }">
                            <div class="multiselect-multiple-label">
                                {{ values.length }} level{{ values.length > 1 ? 's' : ''}}
                            </div>
                        </template>
                    </multiselect>
                    <div v-show="form.pricing_level_ids && form.pricing_level_ids.length">
                        <span v-for="(pricing_level_id, index) in form.pricing_level_ids" :key="pricing_level_id" class="text-xs">
                            {{ pricingLevelOptions[pricing_level_id] }}{{index == form.pricing_level_ids.length - 1 ? '' : ', '}}
                        </span>
                    </div>
                    <jet-input-error :message="$page.props.errors.pricing_level_ids" class="mt-1" />
                </div>
            </div>
        </div>

        <div class="w-1/2">
            <div class="flex mb-2">
                <jet-label for="message" value="Message" class="w-32 align-top leading-7" />
                <div class="flex flex-1 flex-col">
                    <textarea v-model="form.message" class="mt-2 block rounded w-full h-42" maxlength="1000" rows="10" placeholder="Enter a message"></textarea>
                    <jet-input-error :message="$page.props.errors.message" class="mt-1" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import JetLabel from '@/Jetstream/Label';
import JetInput from '@/Jetstream/Input';
import Multiselect from '@vueform/multiselect';
import JetInputError from '@/Jetstream/InputError.vue';

import '@vueform/multiselect/themes/default.css';

export default {
    props: [
        'form',
        'pricingLevelOptions',
    ],

    components: {
        JetLabel,
        JetInput,
        JetInputError,
        Multiselect,
    },
}

</script>

<style>

</style>